<template>
  <l-cache :get-data="getOrganization" :id="$route.query.id" ref="cache">
    <group-content :group="data" :type="type" @refresh="$refs.cache.retry()" slot-scope="{data}"></group-content>
  </l-cache>
</template>

<script>
  import {Group} from '../../../object'
  import GroupContent from '../Group/groupContent'
  export default {
    name: 'reservationGroupDetail',
    components: {GroupContent},
    data: () => ({
      type:'reservationGroup',
    }),
    methods: {
      async getOrganization () {
        let res = await this.$store.dispatch('userAdmin/getOrgListByName', {
          pagination: {page: 1, rowsPerPage: 10},
          id: this.$route.query.id,
          name: '',
          type: 'appt'
        })
        let items
        if (res.data.status === 1) {
          items = res.data.data.content
        }
        else {
          this.$L.alert('error', {message: '查询分组信息失败,原因:' + res.data.msg})
        }
        if (items && items.length > 0) {
          let p = items[0]
          return Group.fromAPI(p)
        }
        else {
          throw Error('未找到该分组')
        }
      },

    }
  }
</script>

<style scoped>

</style>
